<style lang="less" scoped>
.balance-item {
  padding: 0 15px;
  height: 49px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .balance-info {
    display: flex;
    align-items: center;
    .balance-icon {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
    .balance-name {
      font-size: 15px;
      // span{
      //   font-size: 13px;
      //   color: rgb(192, 49, 49);
      // }
      .balance-text {
        font-size: 13px;
      }
    }
    .dedcution-info {
      transform: translateX(-3.5px);
      font-size: 13px;
      color: rgb(121, 125, 130);
    }
    span {
      small.icon-yen {
        font-size: 8px;
      }
    }
  }
  .balance-option {
    display: flex;
    align-items: center;
    font-size: 13px;
    img {
      width: 17px;
      height: 17px;
      margin-left: 15px;
    }
    .option-clicked {
      width: 18px;
      height: 18px;
    }
    span {
      .icon-yen {
        font-size: 8px;
      }
    }
    .option-item {
      color: rgb(25, 26, 27);
    }
  }
}
</style>
<template>
  <div class="balance-item">
    <div class="balance-info">
      <img class="balance-icon" src="../../../../image/preorder/icon_balance.png" alt />
      <div class="balance-name">
        余额（
        <span class="balance-text">剩余</span>
        <decimal-price :forcePoint="true" :price="amount" intergeSize="14px" mystyle="display: inline-table;"></decimal-price>）
      </div>
      <!-- <div class="balance-name">余额（<span><small class="icon-yen">&yen;</small>{{amount | price | priceNumFormat}}</span>）</div> -->
      <div v-if="canUseBalance">
        <!-- <div v-if="dedcutionPrice>0" class="dedcution-info">已抵扣<span><small class="icon-yen">&yen;</small>{{dedcutionPrice | price}}</span></div> -->
        <!-- <div v-if="dedcutionPrice===0" class="dedcution-info">可抵扣<span><small class="icon-yen">&yen;</small>{{deductiblePrice | price}}</span></div> -->
      </div>
    </div>
    <div class="balance-option">
      <div v-if="dedcutionPrice>0">
        <decimal-price :price="dedcutionPrice" myclz="option-item" intergeSize="13px"></decimal-price>
      </div>
      <!-- <div v-if="dedcutionPrice>0"><span><small class="icon-yen">-&yen;</small>{{dedcutionPrice | price}}</span></div> -->
      <img v-if="!canUseBalance" class="option-icon" src="../../../../image/preorder/balance-unable.png" />
      <img v-else-if="dedcutionPrice>0" class="option-icon option-clicked" src="../../../../image/preorder/iconTick.png" @click="cancelUseBalance" />
      <img v-else class="option-icon" src="../../../../image/preorder/unselected.png" @click="useBalance" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import op from 'object-path'
import _ from 'underscore'
import RSA from '../../../util/RSA.js'
import decimalPrice from '../../../components/decimal-price.vue'

const rsa = new RSA()

export default {
  props: ['preorderId'],
  data() {
    return {
      amount: 0, // 余额总额
      couponUsedList: [],
      cardUsedList: [],
    }
  },
  components: {
    'decimal-price': decimalPrice,
  },
  computed: {
    ...mapState({
      isBalancePay: state => state.preorder.payLimit.isBalancePay == 0,
      dedcutionPrice: state => {
        /* 已抵扣 */
        return op(state.preorder.selectedBalance).get('deductionInfo.deductionValue') && state.preorder.hasUsedBalance
          ? op(state.preorder.selectedBalance).get('deductionInfo.deductionValue')
          : 0
      },
      couponList: state => op(state.preorder).get('selectedCoupon.epayList') || [],
      cardList: state => op(state).get('preorder.selectedCards.epayList') || [],
      deductiblePrice: state => {
        /* 可抵扣 */
        return op(state.preorder.selectedBalance).get('deductionInfo.deductionValue') && !state.preorder.hasUsedBalance
          ? op(state.preorder.selectedBalance).get('deductionInfo.deductionValue')
          : 0
      },
    }),
    canUseBalance() {
      return this.isBalancePay && this.amount !== 0 /*  && (this.dedcutionPrice !== 0 || (this.deductiblePrice !== 0 && this.dedcutionPrice === 0)) */
    },
  },
  methods: {
    ...mapActions(['getUserBalance', 'orderCheckPay']),
    useBalance() {
      // 组装卡数据
      if (this.cardUsedList.length === 0) {
        _.each(this.cardList, card => {
          this.cardUsedList.push({
            type: 3,
            content: rsa.encrypt(card.epayId, 'base64'),
          })
        })
      } else if (this.cardList.length === 0) {
        this.cardUsedList = []
      }
      // 组装券数据
      if (this.couponUsedList.length === 0) {
        _.each(this.couponList, coupon => {
          this.couponUsedList.push({
            type: 1,
            content: rsa.encrypt(`${coupon.epayId}`, 'base64'),
          })
        })
      } else if (this.couponList.length === 0) {
        this.couponUsedList = []
      }

      const data = {
        cardList: this.cardUsedList,
        couponList: this.couponUsedList,
        preOrderId: this.preorderId,
        balance: this.amount,
      }
      this.orderCheckPay(data)
        .catch(e => {
          this.$store.commit('rootApperError', e.msg)
        })
        .then(() => {
          this.$store.commit('useBalance')
        })
    },
    cancelUseBalance() {
      this.$store.commit('cancelUseBalance')
    },
  },
  mounted() {
    this.getUserBalance().then(data => {
      this.amount = data.availableAmount
    })
  },
}
</script>
